const tz = require('date-fns-tz');

const DateFns = require('date-fns');
const ptBr = require('date-fns/locale/pt-BR');

module.exports = {
  format: (date, options) => DateFns.format(date, options, { locale: ptBr }),
  basicDate: (date) => DateFns.format(date, 'dd/MM/yyyy'),
  dateWithTimeZone: (date) => tz.format(tz.utcToZonedTime(date, 'Europe/Moscow'), 'dd/MM/yyyy', {
    timeZone: 'Europe/Moscow'
  }),
  differenceInDays: (date, dateToCompare) => DateFns.differenceInDays(date, dateToCompare),
  addDays: (date, days) => DateFns.addDays(date, days),
  dateToBD: (date) => DateFns.format(date, 'yyyy-MM-dd'),
  getDayOfDate: (date) => DateFns.getDate(date),
  isAfter: (date, dateToCompare) => DateFns.isAfter(date, dateToCompare),
  dateWithHours: (date) => DateFns.format(date, 'dd/MM/yyyy HH:mm'),
  basicHour: (date) => DateFns.format(date, 'HH:mm'),
  toIso: (date) => DateFns.formatISO(date),
  parseISO: (date) => DateFns.parseISO(date),
  dateValidator: (date) => /\d{4}-\d{2}-\d{2}/g.test(date),
  getMonth: (date) => DateFns.format(date, 'MM/yy'),
  endOfDay: (date) => DateFns.endOfDay(date)
};
